export const GET_CLIENT_CONFIG = 'GET_CLIENT_CONFIG';
export const CLIENT_CONFIG_LOADING = 'CLIENT_CONFIG_LOADING';
export const CLIENT_CONFIG_SUCCESS = 'CLIENT_CONFIG_SUCCESS';
export const CLIENT_CONFIG_FAILURE = 'CLIENT_CONFIG_FAILURE';
export const GET_NATGEO_FOOTER_LINKS = 'GET_NATGEO_FOOTER_LINKS';
export const NATGEO_FOOTER_LINKS_SUCCESS = 'NATGEO_FOOTER_LINKS_SUCCESS';
export const NATGEO_FOOTER_LINKS_FAILURE = 'NATGEO_FOOTER_LINKS_FAILURE';

export type Actions = {
  GET_CLIENT_CONFIG: { type: typeof GET_CLIENT_CONFIG; payload: string };
  CLIENT_CONFIG_LOADING: { type: typeof CLIENT_CONFIG_LOADING; payload: any };
  CLIENT_CONFIG_SUCCESS: { type: typeof CLIENT_CONFIG_SUCCESS; payload: any };
  CLIENT_CONFIG_FAILURE: { type: typeof CLIENT_CONFIG_FAILURE; payload: any };
  GET_NATGEO_FOOTER_LINKS: { type: typeof GET_NATGEO_FOOTER_LINKS };
  NATGEO_FOOTER_LINKS_SUCCESS: { type: typeof NATGEO_FOOTER_LINKS_SUCCESS; payload: any };
  NATGEO_FOOTER_LINKS_FAILURE: { type: typeof NATGEO_FOOTER_LINKS_FAILURE; payload: any };
};

export const actionCreators = {
  getClientConfig: (magCode: string): Actions[typeof GET_CLIENT_CONFIG] => ({
    type: GET_CLIENT_CONFIG,
    payload: magCode,
  }),
  clientConfigLoading: (
    payload: boolean,
  ): Actions[typeof CLIENT_CONFIG_LOADING] => ({
    type: CLIENT_CONFIG_LOADING,
    payload,
  }),
  clientConfigSuccess: (
    clientConfig: any,
  ): Actions[typeof CLIENT_CONFIG_SUCCESS] => ({
    type: CLIENT_CONFIG_SUCCESS,
    payload: clientConfig,
  }),
  clientConfigFailure: (err: any): Actions[typeof CLIENT_CONFIG_FAILURE] => ({
    type: CLIENT_CONFIG_FAILURE,
    payload: err,
  }),
  getNatGeoFooterLinks: (): Actions[typeof GET_NATGEO_FOOTER_LINKS] => ({
    type: GET_NATGEO_FOOTER_LINKS,
  }),
  natGeoFooterLinksSuccess: (
    natGeoFooterLinks: any,
  ): Actions[typeof NATGEO_FOOTER_LINKS_SUCCESS] => ({
    type: NATGEO_FOOTER_LINKS_SUCCESS,
    payload: natGeoFooterLinks,
  }),
  natGeoFooterLinksFailure: (err: any): Actions[typeof NATGEO_FOOTER_LINKS_FAILURE] => ({
    type: NATGEO_FOOTER_LINKS_FAILURE,
    payload: err,
  }),
};
